/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthSummary {
    getFixupPrototypeFunction() { return ApplicationHealthSummary.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthSummary>): ApplicationHealthSummary {
        let obj = Object.assign(new ApplicationHealthSummary(), model);
        ApplicationHealthSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthSummary>): ApplicationHealthSummary {
        if (!model) return null;
        return ApplicationHealthSummary.newInstance(<ApplicationHealthSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthSummary) {
        if (!obj) return;

        models.ApplicationHealthSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthSummary): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.patch_details) {
            models.PatchCompliance.fixupPrototype(this.patch_details);
        }
        if (this.backup_details) {
            models.ProtectionStatus.fixupPrototype(this.backup_details);
        }
        if (this.disk_details) {
            models.DiskStatus.fixupPrototype(this.disk_details);
        }
        if (this.alert_details) {
            for (let val of this.alert_details) {
                models.ApplicationHealthAlert.fixupPrototype(val);
            }
        }
    }

    /**
     * Service account id
     */
    service_account_id: string;

    /**
     * Service Resource Inventory ID
     */
    service_resource_inventory_id: string;

    /**
     * Application resource ID
     */
    resource_id: string;

    /**
     * Application resource Name
     */
    resource_name: string;

    /**
     * Resource group or logical grouping
     */
    resource_filter: string;

    /**
     * Application region
     */
    resource_region: string;

    /**
     * Resource name
     */
    resource: string;

    /**
     * Type of application resource
     */
    resource_type: string;

    /**
     * Resource category
     */
    resource_category: string;

    /**
     * Current State of the resource
     */
    resource_state: string;

    /**
     * Configured alert metrics
     */
    alert_metrics: Array<string>;

    /**
     * Patch compliance details for the application
     */
    patch_details: models.PatchCompliance;

    /**
     * Backup and protection status
     */
    backup_details: models.ProtectionStatus;

    /**
     * Disk usage and status information
     */
    disk_details: models.DiskStatus;

    /**
     * List of configured alerts and their metrics
     */
    alert_details: Array<models.ApplicationHealthAlert>;

}
